"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopping_cart_filled = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var shopping_cart_filled = function shopping_cart_filled(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'shopping-cart-filled-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("svg", {
    width: '20',
    height: '21',
    viewBox: '0 0 20 21',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, react_1["default"].createElement("g", {
    clipPath: 'url(#clip0_13413_51408)'
  }, react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.19948 5.7023C3.83918 5.7023 4.37564 6.18526 4.44261 6.82144L5.15988 13.6355C5.25363 14.5262 6.00468 15.2023 6.90026 15.2023H15C15.4142 15.2023 15.75 14.8665 15.75 14.4523C15.75 14.0381 15.4142 13.7023 15 13.7023H6.90026C6.77232 13.7023 6.66503 13.6057 6.65164 13.4785L5.93437 6.66442C5.78704 5.26481 4.60681 4.2023 3.19948 4.2023H3V5.7023H3.19948Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M16 16.9523C16 17.5046 15.5523 17.9523 15 17.9523C14.4477 17.9523 14 17.5046 14 16.9523C14 16.4 14.4477 15.9523 15 15.9523C15.5523 15.9523 16 16.4 16 16.9523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7.5 16.9523C7.5 17.5046 7.05228 17.9523 6.5 17.9523C5.94772 17.9523 5.5 17.5046 5.5 16.9523C5.5 16.4 5.94772 15.9523 6.5 15.9523C7.05228 15.9523 7.5 16.4 7.5 16.9523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.565 7.70228H5.5V6.20228H16.5C16.7275 6.20228 16.9427 6.30553 17.085 6.48299C17.2274 6.66044 17.2815 6.89291 17.2321 7.11498L16.2321 11.615C16.1622 11.9296 15.8991 12.1644 15.5785 12.1982L6.07851 13.1982L5.92149 11.7064L14.8849 10.7629L15.565 7.70228Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("g", {
    filter: 'url(#filter0_dd_13413_51408)'
  }, react_1["default"].createElement("rect", {
    x: '8.5',
    y: '0.952271',
    width: '9',
    height: '9',
    rx: '4.5',
    fill: '#DC2626'
  }), react_1["default"].createElement("path", {
    opacity: '0.99',
    d: 'M11.2715 3.33655C10.478 3.33655 9.92139 3.86877 9.92139 4.58899V4.59387C9.92139 5.26038 10.3828 5.74866 11.0688 5.74866C11.5571 5.74866 11.8501 5.50452 11.9771 5.23352H12.0259C12.0259 5.26038 12.0259 5.28723 12.0259 5.31165C11.999 5.95374 11.7744 6.45422 11.2642 6.45422C10.981 6.45422 10.7808 6.3053 10.6953 6.08557L10.688 6.0636H9.96533L9.97021 6.08557C10.0801 6.63733 10.5854 7.04016 11.2666 7.04016C12.1699 7.04016 12.7266 6.33948 12.7266 5.16028V5.1554C12.7266 3.9176 12.0869 3.33655 11.2715 3.33655ZM11.2715 5.20422C10.9028 5.20422 10.6343 4.93811 10.6343 4.56702V4.56213C10.6343 4.20325 10.9199 3.92249 11.2764 3.92249C11.6353 3.92249 11.916 4.20813 11.916 4.57678V4.58167C11.916 4.94543 11.6353 5.20422 11.2715 5.20422ZM13.332 5.8512H14.3867V6.87415H15.0288V5.8512H16.0859V5.20911H15.0288V4.18616H14.3867V5.20911H13.332V5.8512Z',
    fill: 'white'
  }))), react_1["default"].createElement("defs", null, react_1["default"].createElement("filter", {
    id: 'filter0_dd_13413_51408',
    x: '6.5',
    y: '-0.0477295',
    width: '13',
    height: '13',
    filterUnits: 'userSpaceOnUse',
    colorInterpolationFilters: 'sRGB'
  }, react_1["default"].createElement("feFlood", {
    floodOpacity: '0',
    result: 'BackgroundImageFix'
  }), react_1["default"].createElement("feColorMatrix", {
    "in": 'SourceAlpha',
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
    result: 'hardAlpha'
  }), react_1["default"].createElement("feOffset", {
    dy: '1'
  }), react_1["default"].createElement("feGaussianBlur", {
    stdDeviation: '1'
  }), react_1["default"].createElement("feColorMatrix", {
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
  }), react_1["default"].createElement("feBlend", {
    mode: 'normal',
    in2: 'BackgroundImageFix',
    result: 'effect1_dropShadow_13413_51408'
  }), react_1["default"].createElement("feColorMatrix", {
    "in": 'SourceAlpha',
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
    result: 'hardAlpha'
  }), react_1["default"].createElement("feOffset", null), react_1["default"].createElement("feGaussianBlur", {
    stdDeviation: '0.5'
  }), react_1["default"].createElement("feColorMatrix", {
    type: 'matrix',
    values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'
  }), react_1["default"].createElement("feBlend", {
    mode: 'normal',
    in2: 'effect1_dropShadow_13413_51408',
    result: 'effect2_dropShadow_13413_51408'
  }), react_1["default"].createElement("feBlend", {
    mode: 'normal',
    "in": 'SourceGraphic',
    in2: 'effect2_dropShadow_13413_51408',
    result: 'shape'
  })), react_1["default"].createElement("clipPath", {
    id: 'clip0_13413_51408'
  }, react_1["default"].createElement("rect", {
    y: '0.952271',
    width: '20',
    height: '20',
    rx: '2',
    fill: 'white'
  })))));
};

exports.shopping_cart_filled = shopping_cart_filled;